import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

import {
  activityAndMovementTestimonialsData,
  activityAndMovementTestimonialsDataOR4,
} from '../_data/activityAndMovementTestimonialsData';

const ActivityAndMovementTestimonials = (): JSX.Element => {
  //TODO: GROW-1607 clean up Gen3 clean up
  const OR4Enabled = useOuraGen4Enabled();
  return (
    <section data-cy="activity-and-movement-testimonials">
      <LandingPageTestimonials
        testimonials={
          OR4Enabled
            ? activityAndMovementTestimonialsDataOR4
            : activityAndMovementTestimonialsData
        }
        theme="brown"
      />
    </section>
  );
};

export default ActivityAndMovementTestimonials;
